import styled, { css } from "styled-components";
import * as Tooltip from "../../../../../common-deprecated/styles/lexus/Tooltip";
import { theme } from "../../../../../common-deprecated/styles/v2/lexus/theme/lexusTheme";
import { IconWrapper } from "../../../../../common-deprecated/styles/v2/lexus/globals/IconWrapper";

export const Wrapper = styled.div``;

export const Header = styled.header``;

export const Title = styled.h3.attrs(() => ({
    className: "l-gamma-text",
}))`
    margin: ${theme.space[3]}px 0 0;
    text-align: start;
    text-transform: uppercase;
`;

export const InnerCol = styled.div`
    width: 100%;
    padding: ${theme.space[2]}px 0;
`;

export const Label = styled.div.attrs(() => ({
    className: "l-milli-text",
}))`
    margin-bottom: ${theme.space[2]}px;
    text-align: start;
    color: ${theme.colors.platinumDark};
`;

type DescriptionType = { open: boolean; showReadMore: boolean; heightLimit: number; fullHeight: number };

export const Description = styled.span.attrs(() => ({
    className: "l-milli-text",
}))<DescriptionType>`
    margin-top: ${theme.space[2]}px;
    color: ${theme.colors.platinumDark};

    ${({ showReadMore, heightLimit }) =>
        showReadMore &&
        css`
            display: block;
            position: relative;
            max-height: ${heightLimit}px;
            transition: max-height 0.3s;
            overflow: hidden;

            &:after {
                position: absolute;
                bottom: 0;
                left: 0;
                right: 0;
                height: 40px;
                content: "";
                background: linear-gradient(transparent, white);
                transition: opacity 0.3s;
                opacity: 1;
            }
        `};
    ${({ open, fullHeight }) =>
        open &&
        // 20px padding just to be safe
        css`
            display: block;
            max-height: ${fullHeight + 20}px !important;
            padding-bottom: ${theme.space[2]}px;
            overflow: hidden;
            &::after {
                display: none;
                opacity: 0;
            }
        `};
`;

export const Value = styled.div.attrs(() => ({
    className: "l-base-text",
}))`
    display: flex;
    position: relative; /* for tooltip */
    align-items: center;
    min-height: 25px;
    text-align: start;
    color: ${theme.colors.midnight};

    span {
        font-family: ${theme.fonts.book};
        font-size: 1.3rem;
        color: ${theme.colors.midnight};
    }

    ${IconWrapper} {
        display: flex;
        align-items: center;
        margin-right: ${theme.space[1]}px;
    }

    ${Tooltip.Wrapper} {
        width: 400px;
    }

    html[dir="rtl"] & {
        ${IconWrapper} {
            margin-left: ${theme.space[1]}px;
            margin-right: 0;
        }
    }
`;

export const ReadMoreLess = styled.button.attrs(() => ({
    className: "l-milli-text",
}))`
    display: flex;
    padding: 0 ${theme.space[3]}px ${theme.space[2]}px;
    padding-left: 0;
    font-family: ${theme.fonts.bold};
    font-size: 1.4rem;
    line-height: 2rem;
    text-transform: uppercase;
    color: ${theme.colors.azure};
    border: none;

    &:hover {
        color: ${theme.colors.azureHover};
    }

    html[dir="rtl"] & {
        padding-right: 0;
    }
`;
